import _classCallCheck from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import { getCoordsDataType } from './shader_compiler';
export var CumSumProgram = /*#__PURE__*/function () {
  function CumSumProgram(shape, exclusive, reverse) {
    _classCallCheck(this, CumSumProgram);

    this.variableNames = ['x'];
    this.outputShape = shape;
    var rank = shape.length;
    var val = exclusive ? '0.0' : "getX(".concat(getCoords(rank, 'coords'), ")");
    var length = shape[shape.length - 1];
    var condition = '';
    var idxString = ''; // When exclusive is set, the cumsum op becomes roll op that copies the
    // value from the previous index based on the direction specified by the
    // reverse flag.

    if (exclusive) {
      condition = reverse ? "end != ".concat(length - 1) : 'end != 0';
      idxString = reverse ? 'end + 1' : 'end - 1';
    } else {
      condition = reverse ? "end + pow2 < ".concat(length) : 'end >= pow2';
      idxString = reverse ? 'end + pow2' : 'end - pow2';
    }

    this.userCode = "\n      uniform float index;\n      void main() {\n        ".concat(getCoordsDataType(rank), " coords = getOutputCoords();\n        int end = ").concat(getFinalCoord(rank, 'coords'), ";\n        float val = ").concat(val, ";\n        int pow2 = int(pow(2.0, index));\n        if (").concat(condition, ") {\n          int idx = ").concat(idxString, ";\n          ").concat(getFinalCoord(rank, 'coords'), " = idx;\n          val += getX(").concat(getCoords(rank, 'coords'), ");\n        }\n        setOutput(val);\n      }\n    ");
  }

  _createClass(CumSumProgram, [{
    key: "getCustomSetupFunc",
    value: function getCustomSetupFunc(index) {
      var _this = this;

      return function (gpgpu, webGLProgram) {
        if (_this.index == null) {
          _this.index = gpgpu.getUniformLocation(webGLProgram, 'index');
        }

        gpgpu.gl.uniform1f(_this.index, index);
      };
    }
  }]);

  return CumSumProgram;
}();

function getCoords(rank, name) {
  if (rank === 1) {
    return "".concat(name);
  } else if (rank === 2) {
    return "".concat(name, ".x, ").concat(name, ".y");
  } else if (rank === 3) {
    return "".concat(name, ".x, ").concat(name, ".y, ").concat(name, ".z");
  } else if (rank === 4) {
    return "".concat(name, ".x, ").concat(name, ".y, ").concat(name, ".z, ").concat(name, ".w");
  } else {
    throw Error("Cumulative sum for rank ".concat(rank, " is not yet supported"));
  }
}

function getFinalCoord(rank, name) {
  if (rank === 1) {
    return "".concat(name);
  } else if (rank === 2) {
    return "".concat(name, ".y");
  } else if (rank === 3) {
    return "".concat(name, ".z");
  } else if (rank === 4) {
    return "".concat(name, ".w");
  } else {
    throw Error("Cumulative sum for rank ".concat(rank, " is not yet supported"));
  }
}